import React from 'react';

export const Notes = ({ element, setNotes, setEditNote }) => {

  const removeHandler = () => {
    setNotes(prevNotes =>
      prevNotes.filter(elm => elm.id !== element.id)
    );
  };
  const editHandler = () => {
    setEditNote(element);
  };

  return (
    <div className="card mb-3" style = {{border: "2px solid #a7f2faff", borderRadius: "10px", backgroundColor:"#daf3f8ff"}}>
      <div className="card-header">Featured</div>
      <div className="card-body text-capitalize">
        <h5 className="card-title">{element.title}</h5>
        <p className="card-text">{element.desc}</p>

        <button
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#exampleModal"
          onClick={editHandler}
        >
          Edit
        </button>

        <button className="btn btn-danger mx-2" onClick={removeHandler}>
          Remove
        </button>
      </div>
    </div>
  );
};
